var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPrint = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.25V1H13.5V6.25",
    stroke: "#807e80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V7.75C1.5 7.35218 1.65804 6.97064 1.93934 6.68934C2.22064 6.40804 2.60218 6.25 3 6.25H15C15.3978 6.25 15.7794 6.40804 16.0607 6.68934C16.342 6.97064 16.5 7.35218 16.5 7.75V11.5C16.5 11.8978 16.342 12.2794 16.0607 12.5607C15.7794 12.842 15.3978 13 15 13H13.5",
    stroke: "#807e80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10H4.5V16H13.5V10Z",
    stroke: "#807e80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrint, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Print.9fc21b1c.svg";
export { ForwardRef as ReactComponent };